<template>
  <SeoPage page-key="ecommerceSviluppoTicino" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'EcommerceSviluppoTicinoPage'
})
</script>

